import { useNavigate } from 'react-router-dom';

interface BalanceDisplayProps {
  location: 'header' | 'drawer';
  balance: number;
  isLowBalance: boolean;
  isZeroBalance: boolean;
  onClick?: () => void;
}

export const BalanceDisplay = ({
  location,
  balance,
  isLowBalance,
  isZeroBalance,
  onClick,
}: BalanceDisplayProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/manage-plan');
    }
  };

  if (location === 'header') {
    return (
      <button
        onClick={handleClick}
        className={`px-3 py-1 rounded-full text-sm font-semibold transition-colors ${
          isZeroBalance
            ? 'bg-red-600 text-white animate-pulse'
            : isLowBalance
              ? 'bg-red-100 text-red-700 border border-red-300'
              : 'bg-green-100 text-green-700 border border-green-300'
        }`}
        title={isZeroBalance ? 'Balance depleted - click to add credits' : isLowBalance ? 'Low balance - click to add credits' : 'Click to manage your plan'}
      >
        ${balance.toFixed(2)}
      </button>
    );
  }

  // Drawer variant
  return (
    <div className="px-4 py-3 border-t border-neutral-light-gray dark:border-neutral-dark-gray">
      <div className="text-xs text-neutral-medium-gray dark:text-neutral-medium-gray mb-1">
        Account Balance
      </div>
      <div
        className={`text-2xl font-bold ${
          isZeroBalance
            ? 'text-red-600 animate-pulse'
            : isLowBalance
              ? 'text-red-600'
              : 'text-green-600'
        }`}
      >
        ${balance.toFixed(2)}
      </div>
      <button
        onClick={handleClick}
        className="mt-2 w-full px-3 py-1.5 bg-brand-teal hover:bg-brand-teal-hover text-white rounded-md text-sm transition-colors"
      >
        Add Credits
      </button>
    </div>
  );
};
